import React, { useState, useEffect } from "react";
import { FormControlLabel, styled } from "@mui/material";
import Radio from "@mui/material/Radio";
import errorHandler from "../../assets/utils/ErrorHandler";
import appApi from "../../assets/utils/AppApi";

const CustomFormControlLabel = styled(FormControlLabel)({
  marginRight: 0,
  marginBottom: 0,
  fontSize: "14px",
  "& .MuiTypography-root": {
    fontSize: "14px",
  },
});

const RadioItem = ({ item, formId, fieldId }) => {
  const [count, setCount] = useState();
  useEffect(() => {
    getRemainingCount();
  }, []);

  const getRemainingCount = async () => {
    try {
      const data = await appApi.post(`/formfilled/count/selection`, {
        form: formId,
        selectionId: item._id,
        userInput: item.title,
        formField: fieldId,
      });
      setCount(data.data.entries);
    } catch (error) {
      errorHandler(error);
    }
  };

  return (
    <div className="d-flex align-items-center">
      <CustomFormControlLabel
        key={item.id}
        value={item.title}
        control={<Radio />}
        label={item.title}
      />
      {item.limits?.count && (
        <p className="mb-0 mr-3">(ظرفیت باقی مانده: {count})</p>
      )}
    </div>
  );
};

export default RadioItem;
